var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.04 0C4.545 0 0 4.468 0 9.96C0 15.455 4.546 20 10.04 20C15.531 20 20 15.454 20 9.96C20 4.469 15.532 0 10.04 0ZM11.21 15.313C11.21 15.959 10.685 16.484 10.04 16.484C9.72907 16.484 9.43087 16.3606 9.21092 16.1408C8.99097 15.921 8.86726 15.6229 8.867 15.312V9.375C8.867 8.729 9.393 8.203 10.039 8.203C10.685 8.203 11.211 8.729 11.211 9.375V15.313H11.21ZM10.04 5.859C9.72925 5.859 9.43119 5.73569 9.21127 5.51614C8.99135 5.2966 8.86753 4.99875 8.867 4.688C8.867 4.041 9.393 3.516 10.039 3.516C10.685 3.516 11.211 4.041 11.211 4.687C11.211 5.334 10.685 5.859 10.039 5.859H10.04Z",
    fill: "#3889FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.6471190b.svg";
export { ForwardRef as ReactComponent };